module.exports = __webpack_public_path__ + "static/other/gameMailDelivery.7c283e02.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameMailDelivery.json
// module id = 2495
// module chunks = 0